export const merchCapConfig = {
  price: 99,
  oldPrice: 129,
  deliveryPrice: 19.9,
};
